import { ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { useBidMemberListModalStore } from '../../Store/hooks/useContext'

export const ApplyRefreshButton = () => {
  const { tableRef } = useBidMemberListModalStore()

  return (
    <Button
      icon={<ReloadOutlined />}
      type='text'
      onClick={() => {
        tableRef.current?.reload()
      }}
    >
      刷新
    </Button>
  )
}
